var _use, _path, _use2, _path2, _use3, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEbene1Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ebene1_inline_svg__Ebene1_inline_svg___Image1",
    x: 11.38,
    y: 30.382,
    width: 25.059,
    height: 25.85,
    transform: "scale(.96383 .99425)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.034 47.852h-2.493v3.211h-4.626v-3.211h-8.868V44.76l7.526-10.474h4.913l-6.831 9.803h3.404v-2.852h4.482v2.852h2.493v3.763z",
    fill: "#fff",
    fillRule: "nonzero"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ebene1_inline_svg__Ebene1_inline_svg___Image2",
    x: 28.076,
    y: 30.411,
    width: 23.861,
    height: 26.521,
    transform: "scale(.99421 .98228)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.398 51.399c-1.438 0-2.716-.343-3.835-1.031-1.118-.687-1.993-1.689-2.624-3.008-.631-1.318-.947-2.88-.947-4.685 0-1.806.316-3.368.947-4.686s1.506-2.321 2.624-3.008c1.119-.687 2.397-1.031 3.835-1.031 1.422 0 2.693.344 3.811 1.031 1.119.687 1.994 1.69 2.625 3.008s.946 2.88.946 4.686c0 1.805-.315 3.367-.946 4.685-.631 1.319-1.506 2.321-2.625 3.008-1.118.688-2.389 1.031-3.811 1.031zm0-3.883c.799 0 1.434-.387 1.906-1.162.471-.775.707-2.002.707-3.679 0-1.678-.236-2.904-.707-3.679-.472-.775-1.107-1.163-1.906-1.163-.815 0-1.458.388-1.929 1.163-.471.775-.707 2.001-.707 3.679 0 1.677.236 2.904.707 3.679.471.775 1.114 1.162 1.929 1.162z",
    fill: "#fff",
    fillRule: "nonzero"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ebene1_inline_svg__Ebene1_inline_svg___Image1",
    x: 45.821,
    y: 30.382,
    width: 25.059,
    height: 25.85,
    transform: "scale(.96383 .99425)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.229 47.852h-2.493v3.211h-4.625v-3.211h-8.869V44.76l7.526-10.474h4.914l-6.831 9.803h3.403v-2.852h4.482v2.852h2.493v3.763z",
    fill: "#fff",
    fillRule: "nonzero"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "Ebene1_inline_svg__Ebene1_inline_svg___Image1",
    width: 26,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABaklEQVRIiZWWUZLDIAxDBU3vf+Btwv5EGaEIEpjx0LSYZ8vEtGBtlMlvbea4LQJ8ToAInEWoa5JxU7cIe8pIN65iCjrEIuQJ5JCPGEEHgF0AwzqNQFoLQrbTCGonhFlNy/AmI0K+50zpjhOiNVsCJbk2sYoHmdKoAcLZJaNsehhSkEi/17CIJ2sESZszMJWxg6WMWJckmUfqx96P/7X+Y4AiG3/FCOLQ+gyz0OGHQWUjIEH4XOTZOwYgL/GG8QHgTDgdeer4XcNdMp5KBnJlNGs1VRxKWN9sjbaky0elmzVOTNbxO0JcRjiIQ6NiH1OnVPxZh7+BqCsBP/ns0mqN3NevDAB9J/YoXG/V3RVgYLQd/dXRvUfurNnt4uwXHDf8mWlgzaU70BdVg/BGu0ugzOrPINfwIqdZP+sLrb2PIM28y94zwuSZR1hl9RfUa9nU+c3w7FLLGf1RWQL5ep/938/tUlwFvfGLN+8//7CP4g4bnPQAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "Ebene1_inline_svg__Ebene1_inline_svg___Image2",
    width: 24,
    height: 27,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAbCAYAAABm409WAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABZElEQVRIia2W666EIAyEi7rv/8CreP5Y/BwGNSdL0ohKZ9qhXEo8t/Lwf7/7ubwA1ucI1BI5AgKqKSDNEqkTwSdYvrPVA6zCEryRMAMFn2EkSoAaERueJC1JohIRfDmMJI5gEyWYSSNIjQn+AUlmwFaPsat8v8yHSuRIMnpt00GiWeX3JpHTnvKkNKwWBkNwnewym8g/sBngnXNcy3eXcZEZUKIp+vKMuE5oHMT5dH4p02WSNfXsZ0QrCHYBVp/E6iY5ZNAodZ0T9Wv+bh24frdCDbjrd+X3BGCjvPG7ZMAoXeoTvqve6tetZAWv6LOEE9CtD/o0TM2gijH6Jc5J5tbh/FoGjErloAxl8I+b3hpnKbeKmwU4BqCjEib4FwTtICKBgrPpHO1xruwEz/dOoqemRyO3jVWMBPbASQB938IfOCTroo/opfj5mezuPP+9Vbjt5PZSdXcvIpAFfkPwdsztze4PMsm1WRd8W08AAAAASUVORK5CYII="
  }))));
}

export default SvgEbene1Inline;